<div class="alert alert-success" *ngIf="alertDeleteSuccess">
  Hoshin deleted successfully!
</div>
<div class="alert alert-danger" *ngIf="timeOutError">
  {{timeoutErrorMessage}}
</div>
<div class="common-padding">
  <div class="top-section">
    <h4>HOSHIN APPROVAL</h4>
    <div>
      <button type="button" class="eventButton btn btn-danger hoshin-buttons margin-style btn-style"
        (click)="printPdf()"  *ngIf="isNaacAdmin || adminId == 4">PRINT ALL HOSHINS
      </button>
      <button type="button" class="eventButton btn btn-danger hoshin-buttons margin-style btn-style"
        routerLink="../create-hoshin" (click)="createBudget()" *ngIf="!isNaacAdmin && adminId !=4">CREATE
        HOSHIN</button>
      <!-- <button type="button" class="eventButton btn btn-danger hoshin-buttons btn-style" id="additionalBudgetBtn">REQUEST
        ADDITIONAL BUDGET</button> -->
    </div>
  </div>

  <div class="main-section">
    <!--<div class= "outer-div">-->

    <!-- <div class="outer-div">
      <div class="form-group">
        <label for="search">Search</label>
        <input type="text" class="form-control" id="search" maxlength="50" placeholder="Keywords here"
          [(ngModel)]="searchKey" (keyup.enter)="searchBudget()">
      </div>
      <div class="form-group">
        <label class="label-div" for="selectChapter">Select Chapter</label>

        <ng-select placeholder="--Select--" [items]="chapterList" bindLabel="siteName" bindValue="chapterId"
          class="form-control custom" (change)="chapterSelection($event)"></ng-select>

      </div>
    </div> -->
    <div id='included_page' class="form-outer-div">
      <div class="form-group-div">
        <span>
          <ng-select placeholder="--Select SITE--" class="custom" [items]="siteList" bindLabel="siteName"
            bindValue="siteId" [(ngModel)]="siteId" (change)="siteChange($event)"></ng-select>
        </span>
      </div>

      <div class="form-group-div">

        <div>
          <ng-select placeholder="--Select BPG--" class="custom" [items]="bpgList" bindLabel="bpgName"
            [(ngModel)]="bpgId" bindValue="bpgId" (change)="bpgChange($event)"></ng-select>
        </div>
      </div>

      <div class="form-group-div">
        <ng-select placeholder="--Select Status--" class="custom" [items]="statusList" bindLabel="status"
          bindValue="status" [(ngModel)]="status" (change)="changeStatus($event)"></ng-select>
      </div>


      <div class="form-group-div">
        <input type="text" class="form-control keywords" autocomplete="off" id="search"
          placeholder="Search by site and BPG" [(ngModel)]="searchKey">
      </div>
      <div id="searchSecn">
        <button type="button" class="btn btn-danger" (click)="searchBudget()">Search</button>
      </div>
    </div>


  </div>
</div>

<p class="noDataFound" *ngIf="noDataFound"> No data found </p>
<div class="table-data" *ngIf="tableShow">
  <div class="table-container">
    <table aria-describedby="table" [ngClass]="{'table-responsive':tableresp}" class="table table-striped " id="tabledemo">
      <thead>
        <tr class="tr-th">
          <th scope="col" class="width-adjust">Site</th>
          <th scope="col">BPG</th>
          <th scope="col">Budget Source</th>
          <th scope="col" (click)="sortMe('created_by')">Created By <span class="sortupdown"><i id="created_by1"
                class="fa fa-sort-up"></i><i id="created_by2" class="fa fa-sort-down"></i></span></th>
          <th scope="col" (click)="sortMe('created_date_time')">Created Date <span class="sortupdown"><i
                id="created_date_time1" class="fa fa-sort-up"></i><i id="created_date_time2"
                class="fa fa-sort-down"></i></span></th>
          <th scope="col" (click)="sortMe('requested_budget_amount')">Requested Amt <span class="sortupdown"><i
                id="requested_budget_amount1" class="fa fa-sort-up"></i><i id="requested_budget_amount2"
                class="fa fa-sort-down"></i></span></th>
          <th scope="col" (click)="sortMe('approved_budget_amount')">Approved Amt <span class="sortupdown"><i
                id="approved_budget_amount1" class="fa fa-sort-up"></i><i id="approved_budget_amount2"
                class="fa fa-sort-down"></i></span></th>
          <th scope="col" class="width-adjust">Fiscal Year</th>

          <th scope="col" (click)="sortMe('budget_status')">Status <span class="sortupdown"><i id="budget_status1"
                class="fa fa-sort-up"></i><i id="budget_status2" class="fa fa-sort-down"></i></span></th>
          <th scope="col">Action</th>
        </tr>
      </thead>
      <tbody>
        <tr
          *ngFor="let data of budgetList  | paginate: { itemsPerPage: limit, currentPage: currentPage,totalItems: numberOfElements }">
          <td>{{data.siteName}}</td>
          <td>{{data.chapterName}}</td>
          <td>{{data.budgetSource}}</td>
          <td>{{data.createdBy}}</td>
          <td>{{data.dateSubmitted | date:'MM-dd-yyyy'}}</td>
          <td>{{data.requestedBudgetAmount | currency:'USD'}}</td>
          <td>{{data.approvedBudgetAmount | currency:'USD'}}</td>
          <td>{{data.fiscalYear}}</td>

          <td>{{data.budgetStatus}}</td>
          <td>
            <!-- <a class="approveButton" title="Approve" (click)="viewMoreExpenseDetails(data.expenseId,'APPROVED')"><img src="assets/images/approve.png" class="image"></a>
                <a class="rejectButton" title="Reject" (click)="viewMoreExpenseDetails(data.expenseId, 'REJECTED')"><img src="assets/images/reject.png" class="image"></a> -->
            <!-- <a class="viewButton" *ngIf="(adminId==1||adminId==2||adminId==3)&&(data.eventStatus!='NEW'||data.eventStatus!='REJECTED')"><img src="assets/images/view.png" class="image"></a>
                <a (click)="editEvent(data)" *ngIf="(adminId==1||adminId==2||adminId==3)&&(data.eventStatus!='COMPLETED'||data.eventStatus!='CLOSED')" routerLink="../create-event" class="editButton"><img src="assets/images/edit.png" class="image"></a>
                <a class="deleteButton" *ngIf="(adminId==1||adminId==2||adminId==3)&&(data.eventStatus=='NEW'||data.eventStatus=='REJECTED')"><img src="assets/images/delete.png" class="image"></a>
                <a class="completeButton" *ngIf="(adminId==1||adminId==2)&&(data.eventStatus=='SUBMITTED')"><img src="assets/images/complete.png" class="image"></a> -->
            <!-- 1st Approve 1st Reject Buttons -->
            <!-- <a class="approveButton" title="Approve 1"
              *ngIf="(adminId!=3)&&(data.budgetStatus=='SECOND_REJECTED'||data.budgetStatus=='SUBMITTED')"
              (click)="viewMoreExpenseDetails(data.budgetId,'APPROVED')"><img src="assets/images/approve.png"
                class="image"></a>
            <a class="rejectButton" title="Reject 1"
              *ngIf="(adminId!=3)&&(data.budgetStatus=='SECOND_REJECTED'||data.budgetStatus=='SUBMITTED')"
              (click)="viewMoreExpenseDetails(data.budgetId, 'REJECTED')"><img src="assets/images/reject.png"
                class="image"></a> -->
            <!-- 2nd Approve 2nd Reject Buttons -->
            <!-- <a class="approveButton" title="Approve 2" *ngIf="(data.budgetStatus=='FIRST_APPROVED'&&adminId==1)"
              (click)="viewMoreBudgetDetails(data.budgetId,'APPROVED')"><img src="assets/images/approve.png"
                class="image"></a>
            <a class="rejectButton" title="Reject 2" *ngIf="(data.budgetStatus=='FIRST_APPROVED'&&adminId==1)"
              (click)="viewMoreBudgetDetails(data.budgetId, 'REJECTED')"><img src="assets/images/reject.png"
                class="image"></a> -->

            <a class="viewButton" title="View"
              *ngIf="(adminId==1||adminId==2||adminId==3||adminId==4||isNaacAdmin||isbpgLeadAdmin || isbpgAdmin)&&(data.budgetStatus=='SUBMITTED'|| data.budgetStatus=='APPROVED' || data.budgetStatus=='NEW' || data.budgetStatus=='REJECTED')"
              (click)="viewMoreBudgetDetails(data,'VIEW')" routerLink="../view-hoshin"><img src="assets/images/view.png"
                class="image" alt="Angular Logo"></a>
            <a class="editButton" title="Edit" (click)="editBudget(data)"
              *ngIf="(adminId==1||adminId==2||adminId==3||isbpgLeadAdmin || isbpgAdmin)&&(data.budgetStatus=='NEW'|| data.budgetStatus=='REJECTED' )"
              routerLink="../create-hoshin"><img src="assets/images/edit.png" class="image" alt="Angular Logo"></a>
            <a class="editButton" title="Edit" (click)="editBudget(data)"
              *ngIf="(adminId==1||adminId==2||adminId==3||isbpgLeadAdmin || isbpgAdmin)&&(data.budgetStatus=='APPROVED' )"
              routerLink="../edit-approval"><img src="assets/images/edit.png" class="image" alt="Angular Logo"></a>
            <a class="deleteButton" title="Delete" data-toggle="modal" data-target="#myModal"
              (click)="deleteClick(data.budgetId)"
              *ngIf="(adminId==1||adminId==2||adminId==3||isbpgLeadAdmin || isbpgAdmin)&&(data.budgetStatus=='NEW')"><img
                src="assets/images/delete.png" class="image" alt="Angular Logo"></a>
            <a class="cloneButton" title="Clone" data-toggle="modal" data-target="#myModal" (click)="cloneClick(data)"
              *ngIf="(adminId==1||adminId==2||adminId==3||isbpgLeadAdmin || isbpgAdmin)&&(data.budgetStatus=='APPROVED')">
              <img src="assets/images/event_report.png" class="image" alt="Angular Logo">
            </a>
            <!-- <a class="completeButton" *ngIf="(adminId==1||adminId==2)&&(data.eventStatus=='SUBMITTED')"><img src="assets/images/complete.png" class="image"></a> -->

          </td>
        </tr>

      </tbody>
    </table>
    <app-confirmation-modal [PData]="msg1" (emitPass)="this[method](param)" id="1"></app-confirmation-modal>

  </div>

  <div id="bpgpagination" *ngIf="numberOfElements > limit" class="pagination-outerdiv">
    <span>Showing {{currentShowingElements}} of {{numberOfElements}} results</span>
    <pagination-controls previousLabel="Prev" nextLabel="Next" (pageChange)="pageChanged($event)"></pagination-controls>
  </div>
</div>



<div id="printHoshins" [hidden]="true">
<div *ngFor="let budgetData of newList; let j=index;">
  <div class="budget-control-outer-div comman-padding">

  
    <div class="col-md-12 col-xs-12 col-sm-12 div-padding" style="page-break-before: always;">
      <div class="col-md-12 col-xs-12 col-sm-12 heading">
        <span class="span-create-edit-hoshin">HOSHIN VIEW</span>
    
      </div>
  <!-- <hr *ngIf="j != 0" > 
       <div class="col-md-12 chapter-heading">{{budgetData.siteName}}-{{budgetData.chapterName}}</div> -->
      <div class="col-md-6 inlineFlex paddLzero space">
        <span class="col-md-5 paddLzero">Chapter</span>
        <span class="col-md-6 desc-color">{{budgetData.siteName}}-{{budgetData.chapterName}}</span>
      </div>
  
      <div class="col-md-6 inlineFlex paddLzero space">
        <span class="col-md-5 paddLzero">Fiscal Year</span>
        <span class="col-md-6 desc-color">{{budgetData.fiscalYear}}</span>
      </div>
  
      <div class="col-md-6 inlineFlex paddLzero space">
        <span class="col-md-5 paddLzero">Affinity Goals</span>
        <span class="col-md-6 desc-color" [innerHtml]="budgetData.affinityGoals">
        </span>
      </div>
      <div class="col-md-6 inlineFlex paddLzero space">
        <span class="col-md-5 paddLzero">Chapter Goals</span>
        <span class="col-md-6 desc-color" [innerHtml]="budgetData.chapterGoals">
        </span>
      </div>
  
      <div class="col-md-6 inlineFlex paddLzero space">
        <span class="col-md-5 paddLzero">Budget Status</span>
        <span class="col-md-6 desc-color" [innerHtml]="budgetData.budgetStatus">
        </span>
      </div>
  
  
  
    </div>
  
  
    <div class="col-md-12  outerdiv">
      <div class="top-space1 " *ngFor="let hoshin of budgetData.hoshinDetails; let i=index;">
        <div class="div-style">
          <div class="col-md-6 mobile-pading">
            <label class=" budget-control budget-heading budget-name-width">
              <span class="reponse-font">BPG Initiative </span>
            </label>
            <label class="approval respone-hide"
              *ngIf="!hoshin.isSuperAdminApproved && (budgetData.budgetStatus == 'SUBMITTED') && (adminId == 1 || adminId ==4 || isNaacAdmin)">
              (pending approval)
            </label>
            <label class="approval respone-hide"
              *ngIf="hoshin.isSuperAdminApproved && (budgetData.budgetStatus == 'SUBMITTED') && (adminId == 1 || adminId ==4 || isNaacAdmin)">
              (approved)
            </label>
          </div>
          
        </div>
        <hr>
  
        <div id="budgetId{{i}}" class="form-font-family"
          [ngClass]="{'print-display': printClicked == true}">
  
  
          <div class="col-md-6 inlineFlex paddLzero space">
            <label for="bpgInitiative{{i}}" class="col-md-4 paddLzero">BPG Initiative</label>
            <span class="col-md-7 desc-color">{{hoshin.bpgInitiative}}</span>
          </div>
  
          <div class="col-md-6 inlineFlex paddLzero space">
            <label for="status{{i}}" class="col-md-4 paddLzero">Status</label>
            <span class="col-md-7 desc-color">{{hoshin.status}}</span>
          </div>
  
          <div class="col-md-6 inlineFlex paddLzero space">
            <label for="businessDrivers{{i}}" class="col-md-4 paddLzero">Business Drivers</label>
            <span class="col-md-7 desc-color">{{hoshin.businessDrivers}}</span>
          </div>
  
          <div class="col-md-6 inlineFlex paddLzero space" *ngIf="hoshin.proposedBudget">
            <label for="proposedBudget{{i}}" class="col-md-4 paddLzero">Proposed Budget</label>
            <span class="col-md-7 desc-color">${{hoshin.proposedBudget}}</span>
          </div>
  
  
          <div class="col-md-6 inlineFlex paddLzero space">
            <label for="actionPlan{{i}}" class="col-md-4 paddLzero">Frequency</label>
            <span class="col-md-7 desc-color">{{hoshin.frequency}}</span>
         
          </div>
  
          <div class="col-md-6 inlineFlex paddLzero space" *ngIf="hoshin.frequency == 'One-Time'">
            <label for="estimatedTiming{{i}}" class="col-md-4 paddLzero">Estimated Timing</label>
            <span class="col-md-7 desc-color">{{hoshin.estimatedTiming}}</span>
          </div>
  
          <div class="col-md-6 inlineFlex paddLzero space" *ngIf="hoshin.lead1Name">
            <label for="businessDrivers{{i}}" class="col-md-4 paddLzero">Lead 1</label>
            <span class="col-md-7 desc-color">{{hoshin.lead1Name}}</span>
          </div>
  
          <div class="col-md-6 inlineFlex paddLzero space" *ngIf="hoshin.lead2Name">
            <label for="businessDrivers{{i}}" class="col-md-4 paddLzero">Lead 2</label>
            <span class="col-md-7 desc-color">{{hoshin.lead2Name}}</span>
          </div>
  
  
          <div class="col-md-6 inlineFlex paddLzero space" *ngIf="hoshin.actionPlan">
            <label for="actionPlan{{i}}" class="col-md-4 paddLzero">Action Plan</label>
            <span class="col-md-7 desc-color" [innerHtml]="hoshin.actionPlan">
           
            </span>
          </div>
          <div class="col-md-6 inlineFlex paddLzero space" *ngIf="hoshin.kpi">
            <label for="kpi{{i}}" class="col-md-4 paddLzero">KPI</label>
            <span class="col-md-7 desc-color" [innerHtml]="hoshin.kpi">
             
            </span>
          </div>
  
  
          <div class="col-md-6 inlineFlex paddLzero space" *ngIf="hoshin.midYearResults">
            <label for="midYearResults{{i}}" class="col-md-4 paddLzero">Mid Year Results</label>
            <span class="col-md-7 desc-color" [innerHtml]="hoshin.midYearResults">
            </span>
          </div>
          <div class="col-md-6 inlineFlex paddLzero space" *ngIf="hoshin.yearEndResults">
            <label for="yearEndResults{{i}}" class="col-md-4 paddLzero">Year End Results</label>
            <span class="col-md-7 desc-color" [innerHtml]="hoshin.yearEndResults">
             
            </span>
          </div>
        
  
          <div class="col-md-6 inlineFlex paddLzero space" *ngIf="hoshin.challenges">
            <label for="challenges{{i}}" class="col-md-4 paddLzero"> Challenges/Counter Measure</label>
            <span class="col-md-7 desc-color" [innerHtml]="hoshin.challenges">
              {{hoshin.challenges}}
            </span>
          </div>
  
          <div *ngIf="hoshin.additionalFunding != null" class="col-md-6 inlineFlex paddLzero space">
            <label for="additionalFunding{{i}}" class="col-md-4 paddLzero">Additional Funding</label>
            <span class="col-md-7 desc-color">${{hoshin.additionalFunding}}</span>
          </div>
  
          <div *ngIf="hoshin.evaluation != null" class="col-md-6 inlineFlex paddLzero space">
            <label for="evaluation{{i}}" class="col-md-4 paddLzero">Evaluation</label>
            <span class="col-md-7 desc-color">{{hoshin.evaluation}}</span>
          </div>
  
          <div *ngIf="hoshin.additionalFundingSource != null" class="col-md-6 inlineFlex paddLzero space">
            <label for="additionalFundingSource{{i}}" class="col-md-4 paddLzero additional-funding-text-align">Additional
              Funding Source</label>
            <span class="col-md-7 desc-color">{{hoshin.additionalFundingSource}}</span>
          </div>
  
          <div class="col-md-6 inlineFlex paddLzero space"
            *ngIf="hoshin.isSuperAdminApproved && ((this.budgetData.budgetStatus =='SUBMITTED' && (this.adminId == 1 || this.adminId ==4 || isNaacAdmin)) || this.budgetData.budgetStatus == 'APPROVED')">
            <label for="superAdminApprovedBudget{{i}}" class="col-md-4 paddLzero">Approval Amount <span
                *ngIf="this.budgetData.budgetStatus != 'APPROVED'">($)</span>
  
              <label *ngIf="this.budgetData.budgetStatus != 'APPROVED'" class="mandatory-asterisk">*</label></label>
           
            <span *ngIf="this.budgetData.budgetStatus == 'APPROVED'"
              class="col-md-7 desc-color">${{hoshin.superAdminApprovedBudget}}</span>
          </div>
  
          <div class="col-md-6 inlineFlex paddLzero space"
            *ngIf="((this.budgetData.budgetStatus =='SUBMITTED' && hoshin.superAdminApprovalComment && (this.adminId == 1 || this.adminId ==4 || isNaacAdmin)) || ((this.budgetData.budgetStatus == 'APPROVED') && (hoshin.superAdminApprovalComment)) || ((this.budgetData.budgetStatus == 'REJECTED') && (hoshin.superAdminApprovalComment)))">
            <label for="superAdminApprovalComment{{i}}" class="col-md-4 paddLzero remove-padding">Approval/Reject Comment
              <label *ngIf="this.budgetData.budgetStatus != 'APPROVED' && this.budgetData.budgetStatus != 'REJECTED'"
                class="mandatory-asterisk"> *</label></label>
           
            <span *ngIf="this.budgetData.budgetStatus == 'APPROVED' || this.budgetData.budgetStatus == 'REJECTED'"
              class="col-md-7 desc-color">{{hoshin.superAdminApprovalComment}}</span>
          </div>
  
          <div *ngIf="hoshin.claimedAmount != null" class="col-md-6 inlineFlex paddLzero space">
            <label for="claimedAmount{{i}}" class="col-md-4 paddLzero">Claimed Amount</label>
            <span class="col-md-7 desc-color">${{hoshin.claimedAmount}}</span>
          </div>
  
  
        </div>
  
  
      </div>
  
  
      <div class="amount-style">
        <div class="col-md-6 inlineFlex paddLzero space-style paddL" *ngIf="budgetData.requestedBudgetAmount">
          <label class="col-md-6 paddLzero font-headding">Requested Amount </label><span
            class="col-md-1 font-headding">:</span>
          <span class="col-md-5 font-headding">${{budgetData.requestedBudgetAmount}}</span>
        </div>
        <div class="col-md-6 inlineFlex paddLzero space-style">
          <label class="col-md-6 paddLzero font-headding paddM">Approved Amount</label><span
            class="col-md-1 font-headding">:</span>
            <span class="col-md-5 font-headding"  *ngIf="budgetData.approvedBudgetAmount" >${{budgetData.approvedBudgetAmount}}</span>
            <span class="col-md-5 font-headding" *ngIf="!budgetData.approvedBudgetAmount">$0</span>

        </div>
      </div>
  
    
    </div>
  </div>
</div>
  </div>

